/* Henning: central Pflichtangaben link migration */
(function () {
  "use strict";

  var OLD_PATH = "/pages/pflichtangaben";
  var NEW_PATH = "/products/longevity-formulation-system-500ml";

  function rewriteLink(a) {
    var raw = a && a.getAttribute ? a.getAttribute("href") : "";
    if (!raw) return;

    try {
      var url = new URL(raw, window.location.origin);
      var normalized = url.pathname.replace(/\/$/, "");
      if (normalized !== OLD_PATH) return;

      a.setAttribute("href", NEW_PATH + url.search + url.hash);
    } catch (e) {
      if (raw === OLD_PATH || raw === OLD_PATH + "/") a.setAttribute("href", NEW_PATH);
    }
  }

  function rewrite(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll("a[href]").forEach(rewriteLink);
    if (root.matches && root.matches("a[href]")) rewriteLink(root);
  }

  function init() {
    rewrite(document);

    if ("MutationObserver" in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) rewrite(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
